export default "__VITE_ASSET__Bn3AF2HY__"